import React from 'react'
import styled from 'styled-components'
import { Subscribe } from '../components'
import { instagram, youtube } from '../assets/images'


const Center = styled.div`
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  padding:10px;
  p{
    font-size:14px;
    color:#FCDA8B
  }
`
const RowCenter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top:15px;
    img{
        margin: 0px 10px;
        height: 30px;
        width: 30px;
    }
`

const Footer = () => {
  return (
    <>
    <hr style={{border:'1px solid gold', width:'100%'}}/>
    <Subscribe />
    <RowCenter>
      <a href='https://www.youtube.com/@Shayanwahedi' target='_blank' rel='noreferrer' style={{textDecoration:'none'}}>
        <img src={youtube}  alt=''/>
      </a>
      <a href='https://www.instagram.com/shayan.wahedi' target='_blank' rel='noreferrer' style={{textDecoration:'none'}}>
        <img src={instagram}  alt=''/>
      </a>
      {/* <img src={linkedin} alt='' /> */}
    </RowCenter>
    <Center>
      <p>@ {new Date().getFullYear()} Shayan Wahedi. All Rights Reserved.</p>
      <p className='text-end' style={{color:'var(--border)'}}>Designed and developed with ❤️ by <a style={{textDecoration:"none", fontSize:'14px', marginRight:10, color:'var(--border)'}} href='https://livecoder.in' target='_blank' rel="noreferrer">Livecoder</a></p>
    </Center>
    </>
  )
}

export default Footer